import React from 'react';
import PropTypes from 'prop-types';
import { newFormatPrice } from '../../../services/utilityFunctions';

export default function ShopProductVariationPriceDisplay({
  t,
  userPrice,
  userPromotionsPrice,
  customConfig = false,
}) {
  let oldPrice = userPrice
    ? newFormatPrice(userPrice.total, true, userPrice.code)
    : t('free');

  if (customConfig && userPrice?.total === 0) {
    oldPrice = t('free');
  }

  if (!userPromotionsPrice) {
    return (
      <span data-testid="currentPrice" className="only-old-price no-wrap-value">
        {oldPrice}
      </span>
    );
  }

  const promotion = userPromotionsPrice
    ? newFormatPrice(userPromotionsPrice.total, true, userPromotionsPrice.code)
    : t('free');

  return (
    <div className="priceDisplay">
      <span data-testid="oldPrice" className="oldPrice no-wrap-value">
        {oldPrice}
      </span>
      <span data-testid="currentPrice" className="currentPrice no-wrap-value">
        {promotion}
      </span>
    </div>
  );
}

ShopProductVariationPriceDisplay.propTypes = {
  t: PropTypes.func.isRequired,
  userPrice: PropTypes.shape({
    total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    tax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    symbol: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
  }),
  userPromotionsPrice: PropTypes.shape({
    total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    tax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    symbol: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired,
  }),
  customConfig: PropTypes.bool,
};

ShopProductVariationPriceDisplay.defaultProps = {
  userPrice: null,
  userPromotionsPrice: null,
  customConfig: false,
};
